import { LandingCapability, SessionCapability } from 'shared-solo/lib/sessionCapabilities'

type RouteMatch = {
  exact?: readonly string[]
  prefixes?: readonly string[]
  devPrefixes?: readonly string[]
}

const CAPABILITY_ROUTES: Record<SessionCapability, RouteMatch> = {
  home: { prefixes: ['/home'] },
  calendar: { prefixes: ['/calendar'] },
  workingHours: {},
  bookings: { prefixes: ['/bookings'] },
  clients: { prefixes: ['/clients'] },
  team: { prefixes: ['/team'] },
  bookingSystem: { prefixes: ['/booking-system'] },
  website: { prefixes: ['/website'] },
  marketingTools: { prefixes: ['/marketing-tools'] },
  payments: { prefixes: ['/payments'] },
  stats: { prefixes: ['/stats'] },
  googleBusinessProfile: { prefixes: ['/google-business-profile'] },
  subscription: { prefixes: ['/subscriptions'] },
  growthHub: { prefixes: ['/growth-hub-redirect'] },
  accountSettings: { prefixes: ['/account'] },
  /*
    '/account' itself only ever redirects on to /account/overview, the desk's one settings page.
    Listed exactly rather than as a prefix: the desk shares the salon's user record, so anything
    added under /account/overview would show or edit the salon by default. Adding a route here is
    the decision to let the front desk reach it.
  */
  receptionAccount: {
    exact: ['/account', '/account/overview'],
    devPrefixes: ['/account/debug'],
  },
  setupChecklist: {},
  search: {},
  benefits: {},
}

export const LANDING_ROUTES: Record<LandingCapability, string> = {
  home: '/home',
  calendar: '/calendar',
}

const matchesPrefix = (pathname: string, prefix: string): boolean =>
  pathname === prefix || pathname.startsWith(`${prefix}/`)

const matchesRoute = (match: RouteMatch, pathname: string, includeDevRoutes: boolean): boolean => {
  if (match.exact?.includes(pathname)) return true
  if (match.prefixes?.some(prefix => matchesPrefix(pathname, prefix))) return true

  return includeDevRoutes && !!match.devPrefixes?.some(prefix => matchesPrefix(pathname, prefix))
}

export const routeAllowedBy = (
  capabilities: readonly SessionCapability[],
  pathname: string,
  includeDevRoutes: boolean,
): boolean =>
  capabilities.some(capability => matchesRoute(CAPABILITY_ROUTES[capability], pathname, includeDevRoutes))
